import API from './api';

type searchParams = {
  keyword?: string;
  limit?: number;
  offset?: number;
};

class PrivateSellersService extends API {
  static async getMyArtworks(
    keyword?: string,
    limit?: number,
    offset?: number
  ) {
    const params = { keyword, limit, offset };
    const response = await API.get('/private_sellers/artworks', params);
    return response.data;
  }

  static async createArtwork(artwork: any) {
    return await API.post('/private_sellers/artworks/', artwork);
  }

  static async getArtwork(id: number) {
    const response = await API.get(`/private_sellers/artworks/${id}`);
    return response.data;
  }

  static async updateArtwork(id: number, artwork: any) {
    return await API.put(`/private_sellers/artworks/${id}`, artwork);
  }

  static async deleteArtwork(id: number) {
    return await API.delete(`/private_sellers/artworks/${id}`);
  }

  static async getMyArtists(keyword?: string, limit?: number, offset?: number) {
    const params = { keyword, limit, offset };
    const response = await API.get('/private_sellers/artists/mine', params);
    return response.data?.items;
  }

  static async getAllSystemArtists(data: searchParams) {
    const response = await API.get('/private_sellers/artists/system', data);
    return response.data;
  }

  static async createArtist(artist: any) {
    return await API.post('/private_sellers/artists/', artist);
  }

  static async getArtist(id: number) {
    const response = await API.get(`/private_sellers/artists/${id}`);
    return response.data;
  }

  static async updateArtist(id: number, artist: any) {
    return await API.put(`/private_sellers/artists/${id}`, artist);
  }

  static async addArtistToPrivateSeller(id: number) {
    return await API.post(`/private_sellers/artists/${id}`);
  }

  static async removeArtistFromPrivateSeller(id: number) {
    return await API.delete(`/private_sellers/artists/${id}`);
  }

  static async saveArtistsOrder(sortOrder: any) {
    return await API.put(`/private_sellers/artists/order`, {
      sort_order: sortOrder,
    });
  }

  static async saveArtworkOrder(sortOrder: any) {
    return await API.put(`/private_sellers/artworks/order`, {
      sort_order: sortOrder,
    });
  }

  static async getInfo() {
    const response = await API.get('/private_sellers/info');
    return response.data;
  }

  static async updateInfo(data: any) {
    return await API.put('/private_sellers/info', data);
  }

  static async getAttachments(params?: any) {
    const response = await API.get('/private_sellers/attachments', params);
    return response;
  }

  static async createAttachment(attachment: any) {
    return await API.post('/private_sellers/attachments', attachment);
  }

  static async deleteAttachment(id: number, data?: any) {
    return await API.delete(`/private_sellers/attachments/${id}`, data);
  }
}

export default PrivateSellersService;
